<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <project-services />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <slug-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <title-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Sıra No"
            label-for="ordering"
          >
            <validation-provider
              #default="{ errors }"
              name="Sıra No"
              rules="required"
            >
              <b-form-input
                id="ordering"
                v-model="itemData.ordering"
                placeholder="Sıra No"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <summary-text />
        </b-col>
        <b-col cols="12">
          <content-text />
        </b-col>
        <b-col cols="12" md="6">
          <url />
        </b-col>
        <b-col cols="12" md="6">
          <tour360-url />
        </b-col>
      </b-row>
    </b-card>
    <video-embed />
    <kapak-card />
<!--    <image-card />-->
<!--    <thumb-card />-->
    <image2-card />
    <image3-card />
    <photo-gallery />
    <logo />
    <b-button

      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
    <!-- :disabled="!itemData.video_embed || itemData.submitStatus" -->
  </div>

</template>

<script>
import {
  BCard, BCol, BRow, BButton, BFormInput, BFormGroup,
} from 'bootstrap-vue'

import TitleText from '@/views/Admin/Projects/elements/Title.vue'
import SummaryText from '@/views/Admin/Projects/elements/Summary.vue'
import ContentText from '@/views/Admin/Projects/elements/Content.vue'
// import ImageCard from '@/views/Admin/Projects/elements/Image.vue'
import KapakCard from '@/views/Admin/Projects/elements/Kapak.vue'
// import ThumbCard from '@/views/Admin/Projects/elements/Thumb.vue'
import Image2Card from '@/views/Admin/Projects/elements/Image2.vue'
import Image3Card from '@/views/Admin/Projects/elements/Image3.vue'
import PhotoGallery from '@/views/Admin/Projects/elements/PhotoGallery.vue'
import VideoEmbed from '@/views/Admin/Projects/elements/VideoEmbed.vue'
import Logo from '@/views/Admin/Projects/elements/Logo.vue'
import Url from '@/views/Admin/Projects/elements/Url.vue'
import ProjectServices from '@/views/Admin/Projects/elements/ProjectServices.vue'
import SlugText from '@/views/Admin/Projects/elements/Slug.vue'
import { ValidationProvider } from 'vee-validate'
import Tour360Url from '@/views/Admin/Projects/elements/Tour360Url.vue'

export default {
  name: 'ItemForm',
  components: {
    Tour360Url,
    BFormGroup,
    ValidationProvider,
    BFormInput,
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    SummaryText,
    ContentText,
    KapakCard,
    // ImageCard,
    // ThumbCard,
    PhotoGallery,
    VideoEmbed,
    Logo,
    Url,
    ProjectServices,
    Image2Card,
    Image3Card,
    SlugText,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['projects/dataItem']
    },
  },
}
/* <pre>{{
      itemData}}
    </pre> ile verinin dolup dolmadığını anlarım! */
</script>
